import type { Chain } from 'viem';
import { polygon, kaia } from 'viem/chains';

export const SUPPORTED_CHAIN_IDS = [137, 8217] as const;
export type SupportedChainId = typeof SUPPORTED_CHAIN_IDS[number];

export const CHAIN_DEFINITIONS: Record<SupportedChainId, Chain> = {
  137: polygon,
  8217: kaia,
};

export const DEFAULT_CHAIN_ID: SupportedChainId = 137;

export const CHAIN_LABELS: Record<SupportedChainId, string> = {
  137: 'Polygon',
  8217: 'Kaia',
};

export function getChain(chainId: SupportedChainId): Chain {
  return CHAIN_DEFINITIONS[chainId];
}

export function getDefaultChain(): Chain {
  return CHAIN_DEFINITIONS[DEFAULT_CHAIN_ID];
}

export function isSupportedChain(chainId: number): chainId is SupportedChainId {
  return (SUPPORTED_CHAIN_IDS as readonly number[]).includes(chainId);
}
